'use client';

import _ from 'lodash';
import {
  AnalyticsPageView,
  AnalyticsProvider,
} from '@nerdwallet/seo-analytics';
import { useBuilder } from '~/app/lib/redux/selectors/builder-selector';

export const AnalyticsWrapper = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const { flatOutline } = useBuilder();
  const pageConfig = _.filter(
    flatOutline,
    (component) => component.type === 'Page'
  )[0];
  const contentId = pageConfig?.contentId;

  return (
    <AnalyticsProvider>
      <AnalyticsPageView
        name="page_view"
        contentSource="wp"
        contentId={contentId}
      >
        {children}
      </AnalyticsPageView>
    </AnalyticsProvider>
  );
};
